"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteApp = exports.update = exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const Env_1 = require("../../utils/tsUtils/Env");
const appFlavourService_1 = require("./service/appFlavourService");
exports.fetch = (0, toolkit_1.createAsyncThunk)('appFlavour/fetch', (thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const appFlavourService = new appFlavourService_1.AppFlavourService(Env_1.APIPATHENV);
        const response = yield appFlavourService.fetch();
        return response;
    }
    catch (err) {
        throw new Error('Error in fetching app flavours');
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)('appFlavour/create', (createPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const appFlavourService = new appFlavourService_1.AppFlavourService(Env_1.APIPATHENV);
        const response = yield appFlavourService.create(createPayload);
        return response;
    }
    catch (err) {
        throw new Error('Error in creating app flavour');
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)('appFlavour/update', (updatePayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const appFlavourService = new appFlavourService_1.AppFlavourService(Env_1.APIPATHENV);
        const response = yield appFlavourService.update(updatePayload);
        return response;
    }
    catch (err) {
        throw new Error('Error in updating app flavour');
    }
}));
exports.deleteApp = (0, toolkit_1.createAsyncThunk)('appFlavour/delete', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const appFlavourService = new appFlavourService_1.AppFlavourService(Env_1.APIPATHENV);
        const response = yield appFlavourService.update(payload);
        return response;
    }
    catch (err) {
        throw new Error('Error in deleting app flavour');
    }
}));
